import React from 'react';
import { motion } from 'framer-motion';

const LoadingSpinner = ({ message = 'Loading...', fullPage = false, compact = false }) => {
    const spinner = (
        <div style={{ 
            display: 'flex', 
            flexDirection: compact ? 'row' : 'column', 
            alignItems: 'center', 
            justifyContent: 'center', 
            padding: compact ? '0' : '60px 20px',
            textAlign: 'center',
            gap: compact ? '12px' : '0'
        }}>
            <motion.div
                animate={{ rotate: 360 }}
                transition={{ repeat: Infinity, duration: 1, ease: "linear" }}
                style={{ 
                    width: compact ? '18px' : '48px', 
                    height: compact ? '18px' : '48px', 
                    border: compact ? '2px solid rgba(255, 255, 255, 0.3)' : '4px solid rgba(128, 0, 0, 0.1)', 
                    borderTop: compact ? '2px solid white' : '4px solid #800000', 
                    borderRadius: '50%' 
                }}
            />
            {message && (
                <p style={{ 
                    marginTop: compact ? '0' : '20px', 
                    fontWeight: 800, 
                    color: compact ? 'white' : '#800000', 
                    fontSize: compact ? '14px' : '13px', 
                    letterSpacing: compact ? '0.5px' : '1.5px',
                    opacity: 0.9
                }}>
                    {compact ? message : message.toUpperCase()}
                </p>
            )}
        </div>
    );

    if (fullPage) {
        return (
            <div style={{ 
                position: 'fixed', 
                top: 0, 
                left: 0, 
                right: 0, 
                bottom: 0, 
                background: 'rgba(255, 255, 255, 0.8)', 
                backdropFilter: 'blur(4px)',
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                zIndex: 9999 
            }}>
                {spinner}
            </div>
        );
    }

    return spinner;
};

export default LoadingSpinner;
